import axios from 'axios';
import SkeletonInput from 'components/loader/SkeletonInput';
import { useEffect, useState } from 'react';
import AutocompleteSelect, { createFilter } from 'react-select';
import { PAYMENT_METHODS } from 'constants';
import { escapeFilterValue } from 'utils/helpers';

const paymentMethodsOptions = Object.entries(PAYMENT_METHODS).map(([key, value]) => ({
    value: key,
    label: value
}));


export function Autocomplete({
    options,
    label,
    defaultValue = null,
    name,
    onChange,
    placeholder,
    disabled = false
}) {
    
    return (
        <div className="input-wrapper">
        <label className="label-bordered form-label" style={{zIndex: '10'}}>{label}</label>
            <AutocompleteSelect 
                defaultValue={defaultValue ? (options ?? []).find(o => o.value === defaultValue) : null}
                className="form-control"
                classNamePrefix="react-select"
                unstyled
                isClearable
                onChange={autocomplete => onChange({
                    target: {
                        name: name,
                        value: (autocomplete?.value ?? "")
                    }
                })}
                options={(options ?? [])}
                placeholder={placeholder}
                name={name}
                noOptionsMessage={() => "Nessun risultato trovato"}
                isDisabled={disabled}
                filterOption={createFilter({
                    stringify: option => `${option.label} ${option.data?.additional ?? ''}`,
                })}
            />
        </div>
    )
}

export function AutocompleteOrganization({
    autoload = true,
    organizations,
    onChange,
    disabled,
    defaultValue
}) {

    const [organizationsData, setOrganizationsData] = useState();
    
    useEffect(() => {
        if (!autoload && !organizationsData) {
            return setOrganizationsData(organizations);
        }

        axios.get('organizations?autocomplete=1')
        .then(res => setOrganizationsData(res.data));

    }, [autoload, organizations]);

    if (!organizationsData) {
        return <SkeletonInput />;
    };


    return <Autocomplete
        name="organization_id"
        onChange={onChange}
        placeholder="Tutti i clienti"
        label="Cliente"
        options={organizationsData ?? []}
        disabled={disabled}
        defaultValue={defaultValue}
    />
}

export function AutocompletePaydMethod({
    autoload = true,
    paydMethod,
    onChange,
    disabled,
    defaultValue
}){


    return <Autocomplete
        name="payment_method"
        onChange={onChange}
        placeholder="Tutti i metodi di pagamento"
        label="Metodo di pagamento"
        options={paymentMethodsOptions}
        disabled={disabled}
        defaultValue={defaultValue}
        />
        
}

export function AutocompleteProducts({
    products,
    onChange,
    disabled,
    defaultValue
}){
    
    return <Autocomplete
        name="product_id"
        onChange={onChange}
        placeholder="Tutti i servizi"
        label="Servizi"
        options={products}
        disabled={disabled}
        defaultValue={defaultValue}
        />
}